import React, { useEffect, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import {
  useEditBlogMutation,
  useGetBlogByIdQuery,
} from "src/services/BlogServices";
import { BlogFormValues } from "src/models/Blog.model";
import BlogForm from "../Layout/BlogForm";
import { useNavigate, useParams } from "react-router-dom";

const EditBlogFormWrapper = () => {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  const [Blog, setBlogData] = useState<any>({});

  const [editBlog] = useEditBlogMutation();
  const { data, isLoading, isFetching } = useGetBlogByIdQuery(id);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setBlogData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: BlogFormValues = {
    bannerImage: Blog?.bannerImage || "",
    title: Blog?.title || "",
    description: Blog?.description || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    title: string().required("Please enter blog title"),
    description: string().required("Please enter blog description"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BlogFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BlogFormValues>
  ) => {
    const formatedValue = {
      bannerImage: values.bannerImage,
      title: values.title,
      description: values.description,
    };
    editBlog({
      body: formatedValue,
      id: Blog?._id,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          navigate("/website-content/blogs");
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          {(isLoading || isFetching) && (
            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
              <CircularProgress />
            </div>
          )}
          <BlogForm
            formikProps={formikProps}
            formType="Edit"
            setSaveNextChecked={setSaveNextChecked}
            saveNextChecked={saveNextChecked}
          />
        </Form>
      )}
    </Formik>
  );
};

export default EditBlogFormWrapper;
